import TeacherProfile from "@/pages/teachers/print/teacher-profile";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/teachers/$teacherId/profile",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <TeacherProfile />;
}
